import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {map} from 'rxjs/operators';

import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StreamingService {
  private url = environment.urlApiCalendar;
  constructor( private http: HttpClient) { }

  getGameByMlbId(id){
    return this.http.get(this.url + '/calendar/games/' + id).pipe( map( resp => {return resp}));
  }

  getGameByDate(date){
    return this.http.get(`${this.url}/calendar?date=${date}`).pipe( map( resp => {return resp}));
  }

  getGames(){
    return this.http.get(`${this.url}/calendar?date=2020-10`).pipe( map( resp => {
      return resp['response'];
    }));
  }
}
